import { Controller } from "@hotwired/stimulus"

// Toggles appreciation (like) icon animation on click: outline ↔ filled, scale pop, sparks.
// State comes from server (data-icon-appreciation-active-value). Use target_only: true on the icon when the controller is on the parent button.
export default class extends Controller {
  static values = { active: Boolean }
  static targets = ["wrapper"]

  run(event) {
    const el = this.hasWrapperTarget ? this.wrapperTarget : this.element
    const active = this.activeValue
    el.classList.remove("icon-appreciation--activating", "icon-appreciation--reversing")
    el.classList.add(active ? "icon-appreciation--reversing" : "icon-appreciation--activating")
    setTimeout(() => {
      el.classList.remove("icon-appreciation--activating", "icon-appreciation--reversing")
    }, 300)
  }
}
